import { useEffect } from 'react';

import { NavigationProp } from '@react-navigation/core';
import { useNavigation } from '@react-navigation/native';

import { RouteNavigationParams } from 'router/types.ts';

import useOpenTheApp from 'utils/hooks/appBootstrap/useOpenTheApp.ts';
import useSilentLogin from 'utils/hooks/appBootstrap/useSilentLogin.ts';

function Splash() {
    const navigation = useNavigation<NavigationProp<RouteNavigationParams>>();

    const { handleOpenTheApp } = useOpenTheApp(navigation);
    const { handleSilentLogin } = useSilentLogin(navigation, handleOpenTheApp);

    useEffect(() => {
        handleSilentLogin();
    }, []);

    return null;
}

export default Splash;
